import React, { useEffect, useState } from "react";
import { Button, FormControl, FormControlLabel, Radio } from "@mui/material";
import { Container, RadioGroup, Stack, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getCompany, updateGst } from "./companySlice";
import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";

function Gst() {
  const dispatch = useDispatch();
  const { company, companyLoading } = useSelector((state) => state.company);
  const [state, setState] = useState({
    editGst: false,
    editIncome: false,
    editFurther: false,
    gst: "",
    gstType: company.gstType || "Item",
    income: "",
    further: "",
    taxType: "",
  });

  useEffect(() => {
    if (!company && !companyLoading) {
      dispatch(getCompany());
    }
  }, []);

  const toggle = () => {
    if (state.editGst) {
      setState((prev) => ({ ...prev, editGst: false }));
    } else {
      setState((prev) => ({
        ...prev,
        editGst: true,
        gst: company.gst || "",
        gstType: company.gstType || "Item",
      }));
    }
  };

  const toggleIncome = () => {
    if (state.editIncome) {
      setState((prev) => ({ ...prev, editIncome: false }));
    } else {
      setState((prev) => ({
        ...prev,
        editIncome: true,
        income: company.income || "",
        taxType: company.incomeType || "",
      }));
    }
  };

  const toggleFurther = () => {
    if (state.editFurther) {
      setState((prev) => ({ ...prev, editFurther: false }));
    } else {
      setState((prev) => ({
        ...prev,
        editFurther: true,
        further: company.further || "",

        taxType: company.furtherType || "",
      }));
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const handleDisable = (val) => {
    console.log('valll', val)
    if(val == "gst") {
      setState((prev) => ({ ...prev, gst: "disabled" }));
      handleUpdate("disabled","gst");

    } else if(val == "income") {
      setState((prev) => ({ ...prev, income: "disabled" }));
      handleUpdate("disabled","income");

    }  else if(val == "further") {
      setState((prev) => ({ ...prev, further: "disabled" }));
      handleUpdate("disabled","further");

    } 
  };
  const handleUpdate = async (gst, type) => {
    try {
      if (!gst) {
        Toast("info", "Enter GST or Disabled it");
        return;
      }
      console.log("0", gst);
      console.log("1", type);

      let field;
      let fieldType;
      let fieldTypeValue;

      if (type == "gst") {
        field = "gst";
        fieldType = "gstType";
        fieldTypeValue = state.gstType;
      }

      if (type == "income") {
        field = "income";
        fieldType = "incomeType";
        fieldTypeValue = "bill";
      }

      if (type == "further") {
        field = "further";
        fieldType = "furtherType";
        fieldTypeValue = "bill";
      }
      console.log("filed", field);

      console.log("filedType", fieldType);

      console.log("filedTypeValue", fieldTypeValue);
      if (type == "gst") {
        dispatch(updateGst({ gst, gstType: state.gstType }));
      }
      let { data } = await Repo.companies({
        request: {
          method: "updateCompany",
          data: {
            company: {
              ...company,
              [field]: Number(gst),
              [fieldType]: fieldTypeValue,
            },
          },
        },
      });
      setState((prev) => ({
        ...prev,
        editGst: false,
        editIncome: false,
        editFurther: false,
      }));
      if (data.response.status.statusCode == 200) {
        if (type == "gst") {
          localStorage.setItem("gst", gst);
          localStorage.setItem("gstType", state.gstType);
        } else if (type == "income") {
          console.log('ggg', gst)
          localStorage.setItem("income", gst);
          // localStorage.setItem("incomeType", state.taxType);
        } else if (type == "further") {
          console.log("fur");
          localStorage.setItem("further", gst);
          // localStorage.setItem("furtherType", state.taxType);
        }
        console.log("getif");
        dispatch(getCompany());
      } else {
        if (gst == "gst") {
          localStorage.removeItem("gst");
          localStorage.removeItem("gstType");
        } else if (gst == "income") {
          localStorage.removeItem("income");
          localStorage.removeItem("incomeType");
        } else if (gst == "further") {
          localStorage.removeItem("further");
          localStorage.removeItem("furtherType");
        }
        console.log("get");
        dispatch(getCompany());
      }
    } catch (err) {
      console.log("err:", err);
      dispatch(getCompany());
    }
  };

  //   const handleUpdateIncome = async (income) => {
  //     try {
  //       if (!income) {
  //         Toast("info", "Enter Income Tax or Disabled it");
  //         return;
  //       }
  // console.log('income', income)
  //       // dispatch(updateGst({ gst, gstType: state.gstType }));
  //       let { data } = await Repo.companies({
  //         request: {
  //           method: "updateCompany",
  //           data: {
  //             company: {
  //               ...company,
  //               income:income,
  //               incomeType: state.taxType,
  //             },
  //           },
  //         },
  //       });
  //       setState((prev) => ({ ...prev, editIncome: false }));
  //       if (data.response.status.statusCode == 200) {
  //         localStorage.setItem("income", income);
  //         localStorage.setItem("incomeType", state.taxType);
  //       } else {
  //         localStorage.removeItem("income");
  //         localStorage.removeItem("incomeType");

  //         dispatch(getCompany());
  //       }
  //     } catch (err) {
  //       console.log("err:", err);
  //       dispatch(getCompany());
  //     }
  //   };

  //   const handleUpdateFurhter = async (further) => {
  //     try {
  //       if (!further) {
  //         Toast("info", "Enter Further or Disabled it");
  //         return;
  //       }

  //       // dispatch(updateGst({ gst, gstType: state.gstType }));
  //       let { data } = await Repo.companies({
  //         request: {
  //           method: "updateCompany",
  //           data: {
  //             company: {
  //               ...company,
  //               further:further,
  //               furtherType: state.taxType,
  //             },
  //           },
  //         },
  //       });
  //       setState((prev) => ({ ...prev, editFurther: false }));
  //       if (data.response.status.statusCode == 200) {
  //         localStorage.setItem("further", further);
  //         localStorage.setItem("gstTypeFurther", state.taxType);
  //       } else {
  //         localStorage.removeItem("further");
  //         localStorage.removeItem("gstTypeFurther");

  //         dispatch(getCompany());
  //       }
  //     } catch (err) {
  //       console.log("err:", err);
  //       dispatch(getCompany());
  //     }
  //   };
  return (
    <Container sx={{ margin: "25px" }}>
      {state.editGst == false && (
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing="16px">
            <TextField
              variant="outlined"
              value={company.gst ?? "None"}
              disabled
              size="small"
            />
            <FormControl>
              <RadioGroup
                row
                name="gstType"
                value={state.gstType}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="Item"
                  control={<Radio disabled disableRipple />}
                  label="On Item"
                />
                <FormControlLabel
                  value="Bill"
                  control={<Radio disabled disableRipple />}
                  label="On Bill"
                />
              </RadioGroup>
            </FormControl>
          </Stack>
          <Stack direction="row" gap={2}>
            {company?.gst && company?.gst != "disabled" && (
              <Button
                size="small"
                style={{ background: "red", color: "white" }}
                onClick={()=> handleDisable("gst")}
              >
                Disable
              </Button>
            )}
            <Button
              size="small"
              variant="contained"
              style={{ background: "#4EAF51", height: "40px" }}
              onClick={toggle}
            >
              Edit
            </Button>
          </Stack>
        </Stack>
      )}
      {state.editGst == true && (
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing="16px">
            <TextField
              type="number"
              variant="outlined"
              name="gst"
              value={state.gst}
              label="Add GST %"
              size="small"
              onChange={handleChange}
            />
            <FormControl>
              <RadioGroup
                row
                name="gstType"
                value={state.gstType}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="Item"
                  control={<Radio disableRipple />}
                  label="On Item"
                />
                <FormControlLabel
                  value="Bill"
                  control={<Radio disableRipple />}
                  label="On Bill"
                />
              </RadioGroup>
            </FormControl>
          </Stack>
          <Stack direction="row" gap={2}>
            <Button
              size="small"
              variant="outlined"
              style={{ height: "40px" }}
              onClick={toggle}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              style={{ background: "#4EAF51", height: "40px" }}
              onClick={() => handleUpdate(state.gst, "gst")}
            >
              Update
            </Button>
          </Stack>
        </Stack>
      )}

      <h3 style={{ transform: "translateX(-3rem)" }}> Income Tax </h3>

      {state.editIncome == false && (
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing="16px">
            <TextField
              variant="outlined"
              value={company.income ?? "None"}
              disabled
              size="small"
            />
            {/* <FormControl>
              <RadioGroup
                row
                name="income"
                value={state.taxType}
                onChange={handleChange}
              > */}
            {/* <FormControlLabel
                  value="Item"
                  control={<Radio disabled disableRipple />}
                  label="On Item"
                />
                <FormControlLabel
                  value="Bill"
                  control={<Radio disabled disableRipple />}
                  label="On Bill"
                /> */}
            {/* </RadioGroup>
            </FormControl> */}
          </Stack>
          <Stack direction="row" gap={2}>
            {company?.income && company?.income != "disabled" && (
              <Button
                size="small"
                style={{ background: "red", color: "white" }}
                onClick={()=> handleDisable("income")}
              >
                Disable
              </Button>
            )}
            <Button
              size="small"
              variant="contained"
              style={{ background: "#4EAF51", height: "40px" }}
              onClick={toggleIncome}
            >
              Edit
            </Button>
          </Stack>
        </Stack>
      )}

      {state.editIncome == true && (
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing="16px">
            <TextField
              type="number"
              variant="outlined"
              name="income"
              value={state.income}
              label="Add Income Tax"
              size="small"
              onChange={handleChange}
            />
            <FormControl>
              <RadioGroup
                row
                name="taxType"
                value={state.taxType}
                onChange={handleChange}
              >
                {/* <FormControlLabel
                  value="Item"
                  control={<Radio disableRipple />}
                  label="On Item"
                />
                <FormControlLabel
                  value="Bill"
                  control={<Radio disableRipple />}
                  label="On Bill"
                /> */}
              </RadioGroup>
            </FormControl>
          </Stack>
          <Stack direction="row" gap={2}>
            <Button
              size="small"
              variant="outlined"
              style={{ height: "40px" }}
              onClick={toggleIncome}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              style={{ background: "#4EAF51", height: "40px" }}
              onClick={() => handleUpdate(state.income, "income")}
            >
              Update
            </Button>
          </Stack>
        </Stack>
      )}

      <h3 style={{ transform: "translateX(-3rem)" }}> Further Tax </h3>

      {state.editFurther == false && (
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing="16px">
            <TextField
              variant="outlined"
              value={company.further ?? "None"}
              disabled
              size="small"
            />
            <FormControl>
              <RadioGroup
                row
                name="taxType"
                value={state.taxType}
                onChange={handleChange}
              >
                {/* <FormControlLabel
                  value="Item"
                  control={<Radio disabled disableRipple />}
                  label="On Item"
                />
                <FormControlLabel
                  value="Bill"
                  control={<Radio disabled disableRipple />}
                  label="On Bill"
                /> */}
              </RadioGroup>
            </FormControl>
          </Stack>
          <Stack direction="row" gap={2}>
            {company?.further && company?.further != "disabled" && (
              <Button
                size="small"
                style={{ background: "red", color: "white" }}
                onClick={()=> handleDisable("further")}
              >
                Disable
              </Button>
            )}
            <Button
              size="small"
              variant="contained"
              style={{ background: "#4EAF51", height: "40px" }}
              onClick={toggleFurther}
            >
              Edit
            </Button>
          </Stack>
        </Stack>
      )}

      {state.editFurther == true && (
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing="16px">
            <TextField
              type="number"
              variant="outlined"
              name="further"
              value={state.further}
              label="Add Further Tax"
              size="small"
              onChange={handleChange}
            />
            {/* <FormControl>
              <RadioGroup
                row
                name="taxType"
                value={state.taxType}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="Item"
                  control={<Radio disableRipple />}
                  label="On Item"
                />
                <FormControlLabel
                  value="Bill"
                  control={<Radio disableRipple />}
                  label="On Bill"
                />
              </RadioGroup>
            </FormControl> */}
          </Stack>
          <Stack direction="row" gap={2}>
            <Button
              size="small"
              variant="outlined"
              style={{ height: "40px" }}
              onClick={toggleFurther}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              style={{ background: "#4EAF51", height: "40px" }}
              onClick={() => handleUpdate(state.further, "further")}
            >
              Update
            </Button>
          </Stack>
        </Stack>
      )}
    </Container>
  );
}

export default Gst;
